import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FichaDespesaService, FichaReceitaService } from 'administrativo-lib';
import { AnexoLoaService, Anexo1, Anexo2Receita, Anexo2Despesa, Anexo6, Anexo7, Anexo8, Anexo9, Sumario } from 'contabil-lib';
import { Exercicio, ExercicioService, FuncaoService, GlobalService, LoginContabil } from 'eddydata-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';

@Component({
  selector: 'app-transparencia-anexo-loa',
  templateUrl: './transparencia-anexo-loa.component.html'
})
export class TransparenciaAnexoLoaComponent implements OnInit, OnDestroy {

  public login: LoginContabil = new LoginContabil();
  public mes: number;
  public anexoSelect: string;
  public listaExercicios: Array<any>;
  public listaBalancetes: Array<any>;
  public exercicioSelect: Exercicio;
  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    private router: Router,
    protected frService: FichaReceitaService,
    protected fichaService: FichaDespesaService,
    protected exercicioService: ExercicioService,
    protected funcaoService: FuncaoService,
    protected anexoServico: AnexoLoaService) {
    this.login = GlobalService.obterSessaoLogin();
    this.mes = 1;
    this.exercicioSelect = this.login.exercicio;
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngOnInit() {
    this.exercicioService.obterTodosOrdenadoPorAno(this.login.cidade.id).pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        this.listaExercicios = dados.content;
      });
    this.listaBalancetes = [
      { id: 'anexoI', nome: 'ANEXO I - DEMONSTRATIVO DA RECEITA E DESPESA SEGUNDO AS CATEGORIAS ECONÔMICAS' },
      { id: 'anexo2Receita', nome: 'ANEXO II - RECEITAS SEGUNDO AS CATEGORIAS ECONÔMICAS' },
      { id: 'anexo2Despesa', nome: 'ANEXO II - DEMONSTRATIVO DETALHADO SEGUNDO AS CATEGORIAS ECONÔMICAS' },
      { id: 'anexo6', nome: 'ANEXO VI - DEMONSTRATIVO DA DESPESA DAS UNIDADES ORÇAMENTÁRIAS POR PROJETOS,ATIVIDADES E OP.ESPECIEAIS' },
      { id: 'anexo7', nome: 'ANEXO VII - DEMONSTRATIVO DESPESA POR FUNÇÃO SUBFUNÇÃO,PROGRAMA,PROJETOS,ATIVIDADES E OPER.ESPECIAIS' },
      { id: 'anexo8', nome: 'ANEXO VIII - DEMONSTRATIVO DA DESPESA POR FUNÇÕES, SUBFUNÇÕES E PROGRAMAS, CONFORME O VÍNCULO DE RECURSOS' },
      { id: 'anexo9', nome: 'ANEXO IX - DEMONSTRATIVO DA DESPESA POR ÓRGÃOS E FUNÇÕES' },
      { id: 'sumario', nome: 'SUMÁRIO GERAL DA RECEITA POR FONTES E DA DESPESA POR FUNÇÕES DE GOVERNO' }
    ];
  }

  imprimir() {
    const orgaos: number[] = [];
    orgaos.push(this.login.orgao.id);

    if (this.anexoSelect === 'anexoI') {
      const dp = new Anexo1(this.anexoServico);
      dp.montarRelatorio(this.exercicioSelect, orgaos);
    } else if (this.anexoSelect === 'anexo2Receita') {
      const dp = new Anexo2Receita(this.anexoServico);
      dp.montarRelatorio(this.exercicioSelect, orgaos);
    } else if (this.anexoSelect === 'anexo2Despesa') {
      const dp = new Anexo2Despesa(this.anexoServico);
      dp.montarRelatorio(this.exercicioSelect, orgaos);
    } else if (this.anexoSelect === 'anexo6') {
      const dp = new Anexo6(this.anexoServico);
      dp.montarRelatorio(this.exercicioSelect, orgaos);
    } else if (this.anexoSelect === 'anexo7') {
      const dp = new Anexo7(this.anexoServico);
      dp.montarRelatorio(this.exercicioSelect, orgaos);
    } else if (this.anexoSelect === 'anexo8') {
      const dp = new Anexo8(this.anexoServico);
      dp.montarRelatorio(this.exercicioSelect, orgaos);
    } else if (this.anexoSelect === 'anexo9') {
      const dp = new Anexo9(this.anexoServico);
      dp.montarRelatorio(this.exercicioSelect, orgaos);
    } else if (this.anexoSelect === 'sumario') {
      const dp = new Sumario(this.anexoServico);
      dp.montarRelatorio(this.exercicioSelect, orgaos);
    } else {
      toastr.warning('Selecione o anexo a ser impresso');
    }
  }

  sair() {
    this.funcaoService.navegarPara(this.login.usuario.sistema, this.router);
  }

  /**
   * Método para verificação de objetos, usados em combos `<select>`
   */
  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 && c1.id && c2.id ? c1.id === c2.id : c1 === c2;
  }

}
